import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Typography,
  withStyles,
  withWidth,
} from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import { confirmable, createConfirmation } from "react-confirm";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import MaskedInput from "react-text-mask";
import { createNumberMask } from "text-mask-addons";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import InputCheckboxLabel from "../../../components/InputCheckboxLabel";
import InputDateTime from "../../../components/InputDateTime";
import InputImage from "../../../components/InputImage";
import InputSelectSearch from "../../../components/InputSelectSearch";
import InputTextareaEditor from "../../../components/InputTextareaEditor";
import { formatDB } from "../../../components/Utils/Currency";
import CategoryService from "../../../Services/Category/CategoryService";
import TenantService from "../../../Services/TenantService/TenantService";
import DeliveryService from "../../../Services/DeliveryService/index";
import VoucherService from "../../../Services/VoucherService/index";
import VoucherStore from "../../../Store/VoucherStore";
// import { notifUtils } from "../../../components/NotifUtils/NotifUtils";
import { alert } from "../../../components/AlertDialog";
import {
  StyledToggleButton,
  StyledToggleButtonGroup,
} from "../../../components/CustomStyles/CustomToggleButton";
import { useState } from "react";
import { useEffect } from "react";
import FormatNumber from "../../../components/Utils/formatcuRupiah";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
});

// INI ADALAH FORM KETIKA KLIK EDIT
const Form = (props) => {
  const { classes, width, data, cancel, handleGetVoucherList } = props;
  const user = JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(true);
  const [voucherState, voucherActions] = VoucherStore();
  const [state, setState] = React.useState({
    formData: {
      id: "",
      type: "tenant",
      tenant: [],
      name: "",
      description: "",
      terms_condition: "",
      category: "",
      hours_confirmation: false,
      no_cancellation: false,
      price: "",
      discounted_price: "",
      stock: "",
      start_time: moment().utc().format(),
      end_time: moment().utc().format(),
      expired_time: moment().utc().format(),
      image_urls: [],
      voucherType: "Select Voucher Type",
      valueVoucher: "",
      minimumTransaction: "",
      maximumAmountDisc: "",
      isAllTenant: true,
      isDelivey: true,
      code: "",
      quota: "",
      maxUsed: "",
    },
  });
  const [errors, seterrors] = useState({
    voucherType: "voucher type is require",
    image_urls: "image is require",
    code: "Vouchercode has been taken",
    date: "date cant be same",
  });
  const [error, seterror] = useState(false);
  const [quota, setQuota] = useState(0);
  const [selectedTenant, setselectedTenant] = useState([]);
  const [discount, setDiscount] = React.useState(false);
  const [tenant, setTenant] = React.useState(0);
  const [optionsTenant, setOptionsTenant] = React.useState([]);
  const [optionsCategory, setOptionsCategory] = React.useState([]);
  const [checkCode, setcheckCode] = React.useState({
    status: "",
    wording: "",
  });
  const userr = JSON.parse(localStorage.getItem("user"));

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  // console.log(state.formData);
  const handleChange = (event) => {
    const { formData } = state;
    const name = event.target.name;
    const value = event.target.value;
    if (
      name === "valueVoucher" ||
      name === "minimumTransaction" ||
      name === "maxUsed" ||
      name === "quota"
    ) {
      const num = event.target.value;
      const str = num.replace(/\./g, "");
      // console.log(str);
      formData[name] = str;
      setState({ formData });
    } else {
      formData[name] = event.target.value;
      setState({ formData });
    }
  };
  const handleChangeCode = (event) => {
    const value = event.target.value.toUpperCase();
    if (value[value.length - 1] !== " ") {
      const { formData } = state;
      formData[event.target.name] = value;
      setState({ formData });
    }
  };

  const handleChangeTenant = (event) => {
    const { formData } = state;
    if (state.formData.isAllTenant === true) {
      formData[event.target.name] = false;
    } else {
      formData[event.target.name] = true;
    }
    setState({ formData });
  };

  const handleSetTenant = (value) => {
    let newRes = [];

    setTenant(newRes);
  };
  const handleChecked = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.checked;
    setState({ formData });
  };
  console.log(state.formData);
  // FORM SUBMIT
  const handleSubmit = async (e) => {
    const res = await VoucherService.check({ code: state.formData.code });
    // SUBMIT ADD
    if (
      state.formData.voucherType === "Select Voucher Type" ||
      state.formData.start_time === state.formData.end_time
    ) {
      seterror(true);
      // seterror({ ...errors, voucherType: "voucher type is require" });
    } else if (res.data.message === "true" && checkCode.status !== "edit") {
      setcheckCode({ status: "true", wording: "code has been taken" });
      // alert("Warning", "code has been taken");
    } else {
      confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
        if (props.data === null) {
          const { formData } = state;
          formData.tenant = selectedBrand;

          let tipe = "";
          if (formData.voucherType === "Mall") {
            tipe = 1;
          } else if (formData.voucherType === "Tenant") {
            tipe = 2;
          } else if (formData.voucherType === "Ongkir") {
            tipe = 4;
          }
          let selectTenant = [];

          selectedBrand.map((e) => {
            let obj = {
              id: e.value,
            };
            selectTenant.push(obj);
          });
          let selectDelivery = [];

          selectedDelivery.map((e) => {
            let obj = {
              id: e.value,
            };
            selectDelivery.push(obj);
          });

          let voucherType = "";

          if (valueVoucherType === "amount") {
            voucherType = 1;
          } else if (valueVoucherType === "percent") {
            voucherType = 2;
          }

          if (formData.isAllTenant) {
            setselectedBrand([]);
          }

          const newData = {
            code: formData.code,
            name: formData.name,
            description: formData.description,
            snk: formData.terms_condition,
            quota: +formData.quota,
            max_used: +formData.maxUsed,
            type: { id: tipe },
            property: { id: userr.operational.id },
            start_date: formData.start_time,
            end_date: formData.end_time,
            is_all_customer: "1",
            is_all_category: "1",
            is_all_product: "1",
            is_all_tenant: formData.isAllTenant ? "1" : "0",
            tenant: selectTenant,
            minimum_transaction: +formData.minimumTransaction,
            maximum_discount: 0,
            value_type: { id: voucherType },
            value_voucher: +formData.valueVoucher,
            stock: +formData.quota,
            image_voucher: formData.image_urls[0],
            property_id: user.operational.id,
            delivery_package: selectDelivery,
          };

          await voucherActions.store(newData);
          handleCloseDialog();
          handleGetVoucherList(true);
          cancel();
        }
        // SUBMIT EDIT
        else {
          const { formData } = state;
          formData.tenant = selectedBrand;

          let tipe = "";
          if (formData.voucherType === "Mall") {
            tipe = 1;
          } else if (formData.voucherType === "Tenant") {
            tipe = 2;
          } else if (formData.voucherType === "Ongkir") {
            tipe = 4;
          }
          let selectTenant = [];

          selectedBrand.map((e) => {
            let obj = {
              id: e.value,
            };
            selectTenant.push(obj);
          });

          let selectDelivery = [];

          selectedDelivery.map((e) => {
            let obj = {
              id: e.value,
            };
            selectDelivery.push(obj);
          });

          let voucherType = "";

          if (valueVoucherType === "amount") {
            voucherType = 1;
          } else if (valueVoucherType === "percent") {
            voucherType = 2;
          }
          if (formData.isAllTenant) {
            setselectedBrand([]);
            setselectedDelivery([]);
          }

          const calculateStock = formData.quota - quota;

          const result = await VoucherService.getDetail(data.id);
          console.log(result);
          console.log(result);
          const newData = {
            code: formData.code,
            name: formData.name,
            description: formData.description,
            snk: formData.terms_condition,
            quota: result.data.quota,
            max_used: +formData.maxUsed,
            type: { id: tipe },
            property: { id: userr.operational.id },
            start_date: formData.start_time,
            end_date: formData.end_time,
            is_all_customer: "1",
            is_all_category: "1",
            is_all_product: "1",
            is_all_tenant: formData.isAllTenant ? "1" : "0",
            tenant: selectTenant,
            minimum_transaction: +formData.minimumTransaction,
            maximum_discount: 0,
            value_type: { id: voucherType },
            value_voucher: +formData.valueVoucher,
            stock: +result.data.stock + +formData.quota,
            image_voucher: formData.image_urls[0],
            property_id: user.operational.id,
            delivery_package: selectDelivery,
          };
          console.log(newData);
          // const res = await voucherActions.getDetail(data.id);
          console.log(res);
          await voucherActions.put(newData, data.id);
          handleCloseDialog();
          handleGetVoucherList(true);
          cancel();
        }
      });
    }
  };

  const asyncGetOptionsTenant = (query) => {
    return new Promise((resolve, reject) => {
      TenantService.getData({
        property_id:
          user?.type === "staff" &&
          (user?.operational?.level === 1 || user?.operational?.level === 2)
            ? user?.operational?.id
            : "",
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) =>
            user?.operational?.level > 1
              ? { value: row.id, name: `${row.name} - ${row.property.name}` }
              : { value: row.id, name: row.name, image: row.logo.square }
          );
          setOptionsTenant(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const asyncGetOptionsCategory = (query) => {
    return new Promise((resolve, reject) => {
      CategoryService.getData({
        type: "product",
        tenant_id:
          user?.type === "tenant"
            ? user?.tenant?.id
            : state.formData.tenant
            ? state.formData.tenant
            : 0,
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) =>
            user?.type !== "tenant"
              ? {
                  value: row.id,
                  name: `${row.name} -`,
                }
              : { value: row.id, name: row.name }
          );
          setOptionsCategory(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const loadDataRelation = (data) => {
    setLoading(true);
    const tenantName = data ? data?.tenant?.name : "";
    const categoryName = data ? data?.category?.name : "";
    Promise.all([
      asyncGetOptionsTenant(tenantName),
      asyncGetOptionsCategory(categoryName),
    ]).then(() => {
      setLoading(false);
    });
  };

  React.useEffect(() => {
    if (tenant !== 0) {
      asyncGetOptionsCategory();
    }
  }, [tenant]);

  // REACT USEEFFECT AKAN JALAN JIKA MEMBAWA DATA PROP
  React.useEffect(() => {
    loadDataRelation();
    if (data) {
      setState({
        formData: {
          id: data.id,
          code: data.code,
          name: data.name,
          description: data.description,
          terms_condition: data.snk,
          maxUsed: data.max_used,
          type: data.type,
          isAllTenant: data.is_all_tenant === "0" ? false : true,
          valueVoucher: data.value_voucher,
          voucherType:
            data.type.id === 1
              ? "Mall"
              : data.type.id === 2
              ? "Tenant"
              : "Ongkir",
          minimumTransaction: data.minimum_transaction,
          stock: data.stock,
          quota: 0,
          start_time: moment(data.start_date).utc().format(),
          end_time: moment(data.end_date).utc().format(),
          image_urls: [data.image_voucher],
          isDelivey: data.delivery_package ? false : true,
        },
      });
      setQuota(data.quota);
      setcheckCode({ status: "edit", wording: "" });
      let newSelectedBrand = [];
      if (data.tenant) {
        data.tenant.map((e) => {
          let obj = {
            label: e.name,
            logo: e.logo.square,
            value: e.id,
          };
          newSelectedBrand.push(obj);
        });
      }
      let newSelectedDelivery = [];
      if (data.delivery_package) {
        data.delivery_package.map((e) => {
          let obj = {
            label: e.name,
            logo: e.id,
            value: e.id,
          };
          newSelectedDelivery.push(obj);
        });
      }
      if (data.value_type.id === 1) {
        setvalueVoucherType("amount");
      } else {
        setvalueVoucherType("percent");
      }
      setselectedDelivery(newSelectedDelivery);
      setselectedBrand(newSelectedBrand);
    }
  }, [data]);
  // END REACT USEEFFECT

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["bold", "italic", "underline", "list", "bullet"];

  const numberMask = createNumberMask({
    prefix: "",
    sufix: "",
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ".",
    allowDecimal: false,
    decimalSymbol: ",",
  });

  React.useEffect(() => {
    if (discount) {
      ValidatorForm.addValidationRule("lessThanPrice", (value) => {
        if (
          parseInt(formatDB(value)) >= parseInt(formatDB(state.formData.price))
        ) {
          return false;
        }
        return true;
      });
    }
  }, [discount]);

  // new
  const [valueVoucherType, setvalueVoucherType] = useState("amount");

  //  SEARCH BRAND
  const [optionBrand, setoptionBrand] = useState([]);
  const [selectedBrand, setselectedBrand] = useState([]);
  const [insearchBrand, setinsearchBrand] = useState("");
  const [openSelectBrand, setopenSelectBrand] = useState(false);
  const getBrand = async () => {
    const res = await TenantService.getData({
      num: 1000,
      property: user.operational.id,
      cursor: "",
    });
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.logo.square };
      newRes.push(obj);
    });
    setoptionBrand(newRes);
  };

  useEffect(() => {
    getBrand();
  }, []);
  const handleChangeSelectBrand = (value) => {
    const cek = selectedBrand.includes(value);
    if (!cek) {
      setselectedBrand([value]);
    }
  };

  const loadoptionBrand = async (e) => {
    setinsearchBrand(e.target.value);
    const res = await TenantService.getData({
      num: 1000,
      property: "",
      cursor: "",
      keyword: e.target.value,
    });
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.logo.square };
      newRes.push(obj);
    });
    setoptionBrand(newRes);
  };
  // END SEARCH BRAND

  //  SEARCH DELIVERY
  const [optionDelivery, setoptionDelivery] = useState([]);
  const [selectedDelivery, setselectedDelivery] = useState([]);
  const [insearchDelivery, setinsearchDelivery] = useState("");
  const [openSelectDelivery, setopenSelectDelivery] = useState(false);
  const getDelivery = async () => {
    const res = await DeliveryService.getDeliveryPropertyAll(
      user.operational.id
    );
    let newRes = [];

    res.data.map((item, index) => {
      if (index < res.data.length - 1) {
        item.delivery_packages.map((e) => {
          let obj = { value: e.id, label: e.name, logo: e.id };
          newRes.push(obj);
        });
      }
    });
    setoptionDelivery(newRes);
  };

  useEffect(() => {
    getDelivery();
  }, []);

  const handleChangeSelectDelivery = (value) => {
    const cek = selectedDelivery.includes(value);
    if (!cek) {
      setselectedDelivery([...selectedDelivery, value]);
    }
  };

  const loadoptionDelivery = async (e) => {
    setinsearchDelivery(e.target.value);
    const res = await DeliveryService.getPropertyDeliveryVendor({
      num: 1000,
      property: "",
      cursor: "",
      keyword: e.target.value,
    });
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.logo.square };
      newRes.push(obj);
    });
    setoptionDelivery(newRes);
  };
  // END SEARCH DELIVERY

  const handleCheckCode = async () => {
    const res = await VoucherService.check({ code: state.formData.code });
    if (res.data.message === "true") {
      setcheckCode({ status: "true", wording: "code has been taken" });
    } else {
      setcheckCode({ status: "false", wording: "code can be use" });
    }
  };

  return (
    <div>
      <CustomizedDialogs
        disableBackdropClick
        maxWidth={width !== "xs" ? "sm" : false}
        fullScreen={width === "xs"}
        scroll="body"
        open={openDialog}
        handleClose={handleCloseDialog}
      >
        <DialogContent
          classes={{ root: classes.content }}
          dividers
          style={{ padding: "16px 0" }}
        >
          {loading && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </div>
          )}

          {!loading && (
            <ValidatorForm
              id="myForm"
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <Paper
                className={classes.root}
                style={{ boxShadow: "none", padding: "0 24px" }}
              >
                <Grid container>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bolder", fontSize: 18 }}
                    gutterBottom
                  >
                    {props.data ? "Edit Voucher" : "Add New Voucher"}
                  </Typography>
                  <Grid item xs={12}>
                    <div class="dropdown">
                      <button
                        class="btn btn-secondary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        // onChange={handleChange}
                        disabled={props.data ? true : false}
                      >
                        {state.formData.voucherType}
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <div
                          class="dropdown-item"
                          onClick={() => {
                            const { formData } = state;
                            const { voucherType } = formData;
                            formData["voucherType"] = "Mall";
                            formData["isAllTenant"] = true;
                            formData["isDelivey"] = true;

                            setState({ formData });
                          }}
                          value="1"
                        >
                          Mall
                        </div>
                        <div
                          onClick={() => {
                            const { formData } = state;
                            const { voucherType } = formData;
                            formData["voucherType"] = "Tenant";
                            formData["isAllTenant"] = false;
                            formData["isDelivey"] = true;

                            setState({ formData });
                          }}
                          class="dropdown-item"
                          value="2"
                        >
                          Tenant
                        </div>
                        <div
                          class="dropdown-item"
                          onClick={() => {
                            const { formData } = state;
                            const { voucherType } = formData;
                            formData["voucherType"] = "Ongkir";
                            formData["isAllTenant"] = true;
                            formData["isDelivey"] = false;

                            setState({ formData });
                          }}
                          value="3"
                        >
                          Ongkir
                        </div>{" "}
                      </div>
                    </div>
                    {error &&
                    state.formData.voucherType === "Select Voucher Type" ? (
                      <div className="text-danger">{errors.voucherType}</div>
                    ) : null}
                    <div className="d-flex flex-row">
                      <TextValidator
                        id="code"
                        label="Voucher Code Ex: FXSJAYA"
                        name="code"
                        className={classes.textField}
                        margin="normal"
                        value={state.formData.code}
                        type="text"
                        inputProps={{ maxLength: 100 }}
                        helperText={
                          <span
                            style={{ textAlign: "right", display: "block" }}
                          >{`${state.formData.code.length}/100`}</span>
                        }
                        validators={[
                          "required",
                          "maxStringLength:100",
                          "minStringLength:5",
                        ]}
                        errorMessages={[
                          "Name is required",
                          "maximum character is 100",
                          "minimum character is 5",
                        ]}
                        onChange={handleChangeCode}
                        autoFocus
                      />

                      <div
                        className="border-0 p-2 "
                        style={{ marginLeft: "1rem", backgroundColor: "white" }}
                      >
                        <div
                          onClick={handleCheckCode}
                          className="bg-primary text-white p-2"
                          style={{
                            borderRadius: ".3rem",
                          }}
                        >
                          check
                        </div>
                      </div>
                    </div>
                    {checkCode != "" ? (
                      <div
                        className={`${
                          checkCode.status === "true"
                            ? `text-danger`
                            : `text-success`
                        }`}
                      >
                        {checkCode.wording}
                      </div>
                    ) : null}

                    <TextValidator
                      id="name"
                      label="Voucher Name"
                      name="name"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.name}
                      type="text"
                      inputProps={{ maxLength: 100 }}
                      helperText={
                        <span
                          style={{ textAlign: "right", display: "block" }}
                        >{`${state.formData.name.length}/100`}</span>
                      }
                      validators={["required", "maxStringLength:100"]}
                      errorMessages={[
                        "Name is required",
                        "maximum character is 100",
                      ]}
                      onChange={handleChange}
                      autoFocus
                    />
                    <div className="d-flex">
                      {props.data && (
                        <>
                          <div className="w-50 pt-2">
                            <p
                              style={{
                                fontSize: ".7rem",
                                opacity: "0.7",
                                marginTop: ".3rem",
                              }}
                            >
                              Voucher Remain
                            </p>
                            <p className="pl-4" style={{ marginTop: "-.5rem" }}>
                              {FormatNumber(`${state.formData.stock}`)}
                            </p>
                          </div>
                          <div
                            className="w-25"
                            style={{
                              display: "flex",
                              justifyItems: "center",
                              alignItems: "center",
                              fontSize: "2rem",
                              opacity: "0.7",
                            }}
                          >
                            +
                          </div>
                        </>
                      )}
                      <TextValidator
                        id="quota"
                        label={
                          props.data ? "Add Voucher Remain" : "Quota voucher"
                        }
                        name="quota"
                        className={classes.textField}
                        margin="normal"
                        value={FormatNumber(`${state.formData.quota}`)}
                        type="text"
                        inputProps={{ maxLength: 100 }}
                        validators={["required"]}
                        errorMessages={["Name is required"]}
                        onChange={handleChange}
                        autoFocus
                      />
                    </div>
                    <TextValidator
                      id="maxUsed"
                      label="Max used voucher"
                      name="maxUsed"
                      className={classes.textField}
                      margin="normal"
                      value={FormatNumber(`${state.formData.maxUsed}`)}
                      type="text"
                      inputProps={{ maxLength: 100 }}
                      validators={["required"]}
                      errorMessages={["Name is required"]}
                      onChange={handleChange}
                      autoFocus
                    />
                    <div className="form-group mb-4">
                      <label
                        htmlFor="about"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>Choose value voucher type</span>
                      </label>
                      <div className=" d-flex flex-row">
                        <StyledToggleButtonGroup
                          value={valueVoucherType}
                          exclusive
                          aria-label="value voucher"
                        >
                          <StyledToggleButton
                            onClick={() => setvalueVoucherType("percent")}
                            value="percent"
                            aria-label="Percent"
                            disabled
                          >
                            %
                          </StyledToggleButton>
                          <StyledToggleButton
                            onClick={() => setvalueVoucherType("amount")}
                            value="amount"
                            aria-label="Amount"
                          >
                            Fixed Amount
                          </StyledToggleButton>
                        </StyledToggleButtonGroup>
                        {valueVoucherType === "amount" ? (
                          <div
                            style={{ marginTop: "1rem", marginLeft: "1rem" }}
                          >
                            <p>Rp</p>
                          </div>
                        ) : null}
                        {valueVoucherType ? (
                          <TextValidator
                            id="valueVoucher"
                            label="Value voucher"
                            name="valueVoucher"
                            value={FormatNumber(
                              `${state.formData.valueVoucher}`
                            )}
                            type="text"
                            style={{ marginLeft: "1rem" }}
                            inputProps={{ maxLength: 100 }}
                            validators={["required"]}
                            errorMessages={["Name is required"]}
                            onChange={handleChange}
                            autoFocus
                            disabled={props.data ? true : false}
                          />
                        ) : null}
                        {valueVoucherType === "percent" ? (
                          <div style={{ marginTop: "1rem" }}>
                            <p>%</p>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* SEARCH BRAND */}
                    {!state.formData.isAllTenant ? (
                      <>
                        <label>Select Tenant</label>
                        {selectedBrand.map((e, index2) => {
                          return (
                            <div
                              class="alert alert-info d-flex justify-content-between align-items-center"
                              role="alert"
                            >
                              <img
                                src={e.logo}
                                style={{
                                  width: "2rem",
                                  height: "2rem",
                                  marginRight: "1rem",
                                }}
                                alt=""
                              />
                              <div>{e.label}</div>
                              <div
                                onClick={() => {
                                  console.log("ihza");
                                  const newselected = selectedBrand.filter(
                                    (item, index) => {
                                      if (index2 !== index) {
                                        return item;
                                      }
                                    }
                                  );
                                  setselectedBrand(newselected);
                                }}
                              >
                                <div className="cursor-pointer">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-trash3"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          );
                        })}

                        <div class="dropdown mt-3 mb-3">
                          <TextValidator
                            label="search your Brand"
                            name="search"
                            className={classes.textField}
                            variant="outlined"
                            value={insearchBrand}
                            type="text"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            inputProps={{ maxLength: 61 }}
                            onChange={loadoptionBrand}
                            autoComplete="off"
                          />

                          <div
                            className="dropdown-menu overflow-auto"
                            aria-labelledby="dropdownMenuButton"
                            style={{ width: "100%", height: "200px" }}
                          >
                            {optionBrand.map((e) => {
                              return (
                                <div>
                                  <div
                                    class="dropdown-item"
                                    onClick={() => {
                                      setinsearchBrand(e.label);
                                      handleChangeSelectBrand(e);
                                      setopenSelectBrand(false);
                                    }}
                                  >
                                    <img
                                      src={e.logo}
                                      style={{
                                        width: "2rem",
                                        height: "2rem",
                                        marginRight: "1rem",
                                      }}
                                      alt=""
                                    />
                                    {e.label}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </>
                    ) : null}
                    {/* END SEARCH BRAND */}

                    {/* SEARCH DELIVERY */}
                    {!state.formData.isDelivey ? (
                      <>
                        <label>Select Delivery</label>
                        {selectedDelivery.map((e, index2) => {
                          return (
                            <div
                              class="alert alert-info d-flex justify-content-between align-items-center"
                              role="alert"
                            >
                              <div>{e.label}</div>
                              <div
                                onClick={() => {
                                  const newselected = selectedDelivery.filter(
                                    (item, index) => {
                                      if (index2 !== index) {
                                        return item;
                                      }
                                    }
                                  );
                                  setselectedDelivery(newselected);
                                }}
                              >
                                <div className="cursor-pointer">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-trash3"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          );
                        })}

                        <div class="dropdown mt-3 mb-3">
                          <TextValidator
                            label="Search Your Delivery"
                            name="search"
                            className={classes.textField}
                            variant="outlined"
                            value={insearchDelivery}
                            type="text"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            inputProps={{ maxLength: 61 }}
                            onChange={loadoptionDelivery}
                            autoComplete="off"
                            // autoFocus
                          />

                          <div
                            className="dropdown-menu overflow-auto"
                            aria-labelledby="dropdownMenuButton"
                            style={{ width: "100%", height: "200px" }}
                          >
                            {optionDelivery.map((e) => {
                              return (
                                <div>
                                  <div
                                    class="dropdown-item"
                                    onClick={() => {
                                      setinsearchDelivery(e.label);
                                      handleChangeSelectDelivery(e);
                                      setopenSelectDelivery(false);
                                    }}
                                  >
                                    {e.label}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </>
                    ) : null}
                    {/* END SEARCH DELIVERY */}

                    <TextValidator
                      id="minimumTransaction"
                      label="Minimum Payment"
                      name="minimumTransaction"
                      className={classes.textField}
                      margin="normal"
                      value={FormatNumber(
                        `${state.formData.minimumTransaction}`
                      )}
                      type="text"
                      inputProps={{ maxLength: 100 }}
                      helperText={
                        <span
                          style={{ textAlign: "right", display: "block" }}
                        >{`${state.formData.name.length}/100`}</span>
                      }
                      validators={["required"]}
                      errorMessages={["Name is required"]}
                      onChange={handleChange}
                      autoFocus
                      disabled={props.data ? true : false}
                    />
                    <InputTextareaEditor
                      id="description"
                      name="description"
                      value={state.formData.description}
                      modules={modules}
                      formats={formats}
                      showToolBar={false}
                      onChange={(e) => handleChange({ target: e })}
                      validators={["required"]}
                      errorMessages={["Description is required"]}
                      placeholder="Add description"
                      helperText={
                        <span
                          style={{ textAlign: "right", display: "block" }}
                        >{`${state.formData.description.length}/2000`}</span>
                      }
                    />
                    <InputTextareaEditor
                      id="terms_condition"
                      name="terms_condition"
                      value={state.formData.terms_condition}
                      modules={modules}
                      formats={formats}
                      showToolBar={false}
                      onChange={(e) => handleChange({ target: e })}
                      validators={["required"]}
                      errorMessages={["Terms & Condition is required"]}
                      placeholder="Add terms &amp; condition"
                      helperText={
                        <span
                          style={{ textAlign: "right", display: "block" }}
                        >{`${state.formData.terms_condition.length}/2000`}</span>
                      }
                    />
                  </Grid>
                </Grid>
              </Paper>
              <Paper
                className={classes.root}
                style={{
                  boxShadow: "none",
                  padding: "16px 24px",
                  borderBottom: "4px solid #EEEEEE",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: "bolder", fontSize: 18 }}
                  gutterBottom
                >
                  Date
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <InputDateTime
                      id="start_time"
                      name="start_time"
                      ampm={false}
                      format="dd/MM/yyyy HH:mm"
                      // disablePast={true}

                      minDate={
                        data ? data.start_time : state.formData.start_time
                      }
                      label="Start Time"
                      disabled={props.data ? true : false}
                      className={classes.textField}
                      value={state.formData.start_time}
                      onChange={(date) => {
                        handleChange({
                          target: {
                            name: "start_time",
                            value: moment.utc(date).format(),
                          },
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "Change start date",
                      }}
                      validators={["required"]}
                      errorMessages={["Start date is required"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputDateTime
                      id="end_time"
                      name="end_time"
                      ampm={false}
                      format="dd/MM/yyyy HH:mm"
                      // disablePast={true}
                      disabled={props.data ? true : false}
                      minDate={data ? data.end_time : state.formData.end_time}
                      label="End Time"
                      className={classes.textField}
                      value={state.formData.end_time}
                      onChange={(date) => {
                        handleChange({
                          target: {
                            name: "end_time",
                            value: moment.utc(date).format(),
                          },
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "Change end date",
                      }}
                      validators={["required"]}
                      errorMessages={["End date is required"]}
                    />
                  </Grid>
                </Grid>
                {error &&
                state.formData.start_time === state.formData.end_time ? (
                  <div className="text-danger">{errors.date}</div>
                ) : null}
              </Paper>
              <Paper
                className={classes.root}
                style={{
                  boxShadow: "none",
                  padding: "16px 24px",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: "bolder", fontSize: 18 }}
                  gutterBottom
                >
                  Graphic
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <Typography
                      variant="subtitle2"
                      style={{ fontSize: 13, fontWeight: "bolder" }}
                    >
                      Voucher Picture
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={9} md={9} lg={9}>
                    <InputImage
                      image={state.formData.image_urls[0] || ""}
                      maxSize={1000}
                      aspectW={16}
                      aspectH={9}
                      removeType="reset"
                      onUploadDone={(url) => {
                        const { formData } = state;
                        formData.image_urls = [url];
                        setState({ formData });
                      }}
                      onRemove={(url) => {
                        const { formData } = state;
                        formData.image_urls = [];
                        setState({ formData });
                      }}
                      style={{
                        marginTop: "0px !important",
                        width: "100%",
                        height: 240,
                        maxWidth: "100%",
                        maxHeight: 240,
                      }}
                      styleWrapper={{ borderColor: "#BDBDBD", borderRadius: 0 }}
                      styleImage={{ height: "auto", width: "100%" }}
                    />
                    {error && state.formData.image_urls.length === 0 ? (
                      <div className="text-danger">{errors.image_urls}</div>
                    ) : null}

                    <br />
                    <p
                      style={{
                        fontSize: 10,
                        color: "#757575",
                        lineHeight: 1,
                        marginLeft: "1rem",
                      }}
                    >
                      JPEG or 32-bit PNG
                      <br />
                      1280 px by 720 px
                      <br />
                      16:9
                      <br />
                      Up to 1 MB
                    </p>
                  </Grid>
                </Grid>
              </Paper>
            </ValidatorForm>
          )}
        </DialogContent>
        {!loading && (
          <DialogActions>
            <Button
              onClick={() => {
                handleCloseDialog();
              }}
              style={{
                color: "#BDBDBD",
                fontSize: 13,
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Button>
            {!data && (
              <Button
                type="submit"
                form="myForm"
                variant="contained"
                style={{
                  backgroundColor: "#007BFF",
                  color: "#FFFFFF",
                  fontSize: 13,
                  marginRight: 30,
                  borderRadius: 0,
                  boxShadow: "none",
                  textTransform: "capitalize",
                }}
              >
                Create
              </Button>
            )}
            {data && (
              <Button
                type="submit"
                form="myForm"
                variant="contained"
                style={{
                  backgroundColor: "#2196F3",
                  color: "#FFFFFF",
                  fontSize: 13,
                  marginRight: 30,
                  borderRadius: 0,
                  boxShadow: "none",
                  textTransform: "capitalize",
                }}
              >
                Save
              </Button>
            )}
          </DialogActions>
        )}
      </CustomizedDialogs>
    </div>
  );
};

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
  handleGetVoucherList: PropTypes.func,
};
export function showForm(data, handleGetVoucherList, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      data,
      handleGetVoucherList,
      ...options,
    }
  );
}
